// src/components/BillingPeriodToggle.js
import React from 'react';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Chip
} from '@mui/material';

const BillingPeriodToggle = ({ value, onChange, disabled = false }) => {
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        disabled={disabled}
        sx={{
          '& .MuiToggleButton-root': {
            px: 3,
            py: 1.5,
            border: '2px solid',
            borderColor: 'primary.main',
            color: 'primary.main',
            fontWeight: 600,
            fontSize: '1rem',
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': {
                backgroundColor: 'primary.dark',
              }
            },
            '&:hover': {
              backgroundColor: 'primary.light',
              color: 'primary.contrastText',
            }
          }
        }}
      >
        <ToggleButton value="monthly">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography>Monthly</Typography>
          </Box>
        </ToggleButton>
        <ToggleButton value="annual">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography>Annual</Typography>
            <Chip 
              label="2 Months FREE" 
              size="small" 
              sx={{ 
                bgcolor: 'success.main', 
                color: 'success.contrastText',
                fontWeight: 600,
                fontSize: '0.75rem',
                height: 20
              }} 
            />
          </Box>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default BillingPeriodToggle;